/* eslint-disable */
/**
 * eslint-disable [нецензурно] замучил. мы не будем переписывать ради него весь этот файл\
 *
 *
	Функция автосоздания плагина по образу и подобию фоторепортажей и интерактивных презентаций - вставляет элемент с дата-атрибутом, который затем обрабатывается на морде с аяксом

	Вызывается из plugins\<imaps|pion|photoreports>\plugin.js

	Принимает параметры в виде объекта props
	— name - строка, основное имя плагина (соотв. должно совпадать с папкой в /plugins/, с вызовом в config.plugins и тд - см. по тексту этой функции)
	— buttonTitleSuffix - слово для имени-тултипа кнопки
	— windowTitleSuffix - слово для имени-тайтла попап-окошка tinymce

	Помимо этого объекта есть ещё различия для разных плагинов, которые я решил в props не вписывать дабы не усложнять, а тупо оставить захардкоженными в соотв. функциях:
	— получение/генерация ссылки на вспл. арм (см. getLookupArmId)
	— обработка полученного из вспл. арма значения (см. setVal)

*/

import urlUtil from '@uarm/src/util-url.js';


window.UARM_TMCE_UTIL = window.UARM_TMCE_UTIL || {};
window.UARM_TINYMCE_FOCUSED_EL = null;

var classNameSuffix = '_holder';
var idCtrlName = 'id_inp'; // имя контрола ввода айди чего-либо, исп. в презентациях/фоторепортажах
var floatCtrlName = 'float_inp'; // имя контрола выбора обтекания
var urlCtrlName = 'url_inp';
var wCtrlName = 'w_inp';
var hCtrlName = 'h_inp';
var already_registered_popup_picker_ctrls = {}; // объект контроля чтобы одинаковый контрол (кнопки выбора чего-то) не был проинициализирован дважды
var ctrlCode_to_armId = {
	c_dbmm: 777005,
	c_pion: 2296, // ждет https://jira.oooinex.ru/browse/PIRS2018-750
	c_icons: 1085601,
	c_photoreports: 2411,
	c_imaps: 2505,
	c_livecharts: 2850,
	c_media2: 777005,
};

// Инициализация контрола с кнопкой (кнопками) выбора чего-либо из всплывающего АРМ
// контрол инициализируется не один, потому что действия кнопок разные для разных плагинов (например вставки картинки и выбора фоторепортажа)
// этот контрол в дальнейшем будет использован в плагинах, CTRL+F "UARM_TMCE_UTIL.getCustomCtrl"
function registerPopupPickerCtrl(pluginCode, options = {}) {
	if (already_registered_popup_picker_ctrls[pluginCode]) {
		return;
	}
	already_registered_popup_picker_ctrls[pluginCode] = 1;

	var ctrlCode = getCtrlCodeByPlugin(pluginCode);
	var isDBMM = ctrlCode === 'c_dbmm' || ctrlCode === 'c_media2';
	var isPhotorep = ctrlCode === 'c_photoreports';


	var nameDstCtrl = options && options.hasOwnProperty('destination') ? options['destination'] : null;

	var ctrl = window.tinymce.ui.Control.extend({
		Defaults: {
			classes: 'widget',
			// role: 'button'
		},
		init: function (settings) {
			var self = this;
			self._super(settings);
			settings = self.settings;
		},
		icon: function (icon) {
			if (!arguments.length) {
				return this.state.get('icon');
			}
			this.state.set('icon', icon);
			return this;
		},
		repaint: function () {
			var btnElm = this.getEl().firstChild;
			this._super();
		},
		renderHtml: function () {
			return `
			<div id="${this._id}" class="${this.classes} jf-wrap">
				<table class="full-width">
					<tr>
					${
						isDBMM
							? '<td style="padding-right: 1em;"><button class="btn btn-default full-width --ex-primary jf-btn-disk" data-test-id="selectFromPC">Выбрать с компьютера</button></td>'
							: ''
					}
					<td>
						<button class="btn btn-default full-width --ex-primary jf-btn-db" data-test-id="selectFromDBMM">Выбрать из БД</button>
					</td>
					</tr>
				</table>
			</div>
		`;
		},
		postRender: function () {
			var ctrlInstance = this;
			var tinymceInstance = window.tinymce.activeEditor; // из контрола нельзя получить инстанс
			var wrap = ctrlInstance.getEl();

			var btnDisk = wrap.querySelector('.jf-btn-disk');
			var btnDb = wrap.querySelector('.jf-btn-db');

			var arm_id = ctrlCode_to_armId[ctrlCode];

			if (!arm_id) {
				throw 'Не найдено соответствие ID АРМ контролу ' + ctrlCode;
			}

			var propsToPass = {
				arm_id,
				pick_type: 'single',
				record_id: 0, // используется только в карточке, т.е. при выборе файла с диска
			};

			if (isDBMM) {
				// Выбрать с компьютера
				btnDisk.addEventListener('click', function (evt) {
					var getValueHandler = function (recordsArray) {
						// событие popup_upsert - создание/обновление записи в попапе,
						// аргумент - список созданных/обновленных записей
						var vm = this;
						var item = recordsArray[0];
						var fileProps = item.fields.filter((f) => f.fieldId.toUpperCase() === 'ID')[0].value; // поле с файлом в АРМ БДММ называется ID и в ответе отдает свойства
						var filePropsName = item.fields.filter((f) => f.fieldId.toUpperCase() === 'NAME')[0].value; // имя файла
						var filePathOrId = item.path || item.primaryKeyValue;

						var ext = item.fields.filter((f) => f.fieldId.toUpperCase() === 'FORMAT_ID')[0].value; // расширение файла;
						var size = item.fields.filter((f) => f.fieldId.toUpperCase() === 'SIZE')[0].value; // размер файла
						var group = item.fields.filter((f) => f.fieldId.toUpperCase() === 'FORMAT_GROUP_ID')[0].rawValue;

						setVal(getFileLink(filePathOrId, filePropsName), filePropsName, ext, size, group, nameDstCtrl);

						if (!filePathOrId) {
							console.log('Путь к файлу не получен!');
							console.log('Данные записи в целом: ', item);
							console.log('Данные поля с файлом: ', fileProps);
						}
					};
					tinymceInstance.CUSTOM__openArm(propsToPass, getValueHandler, false);
				});
			}

			// Выбрать из БД
			btnDb.addEventListener('click', function (evt) {
				// событие popup_select - выбор записи в попапе
				// аргумент - выбранная запись
				var getValueHandler = function (item) {
					var vm = this;
					var idCustom = item.ITEM_ID;
					if (pluginCode === 'icons') {
						idCustom = item.data_id.fileId;
					}
					if (isDBMM) {
						setVal(
							getFileLink(item.ITEM_ID, item.file_name),
							item.name,
							item.format_id ? item.format_id : null,
							item.size ? item.size : null,
							item.format_group_id ? item.format_group_id : null,
							nameDstCtrl
						);
					} else {
						// не факт что сюда можно попасть
						console.log('Выбрать из БД, опция 2');
						if (pluginCode === 'icons') {
							setVal(item.ITEM_ID, idCustom, item.data_id.width, item.data_id.height);
						} else {
							setVal(item.ITEM_ID);
						}
					}
				};
				tinymceInstance.CUSTOM__openArm(propsToPass, getValueHandler, true);
			});

			function getFileLink(pathOrId, filename) {
				var fileNameSuffix = pluginCode === 'media' || pluginCode === 'link' ? '?action=download' : ''; //filename ? ('?filename=' + filename) : ''; // для того чтобы на морде можно было определить тип, кажется это было сделано для FLV и следовательно скоро станет неактуальным
				var urlPathPrefix = typeof pathOrId === 'string' ? urlUtil.mediaContext : urlUtil.mediaContextApi; // если передан айди, берем файл через АПИ
				return (
					urlPathPrefix + pathOrId + fileNameSuffix
				); /* urlUtil.getDomain() домен для медиа в визарде будет дописан редиректом, см. background.js */
			}
		},
		bindStates: function () {
			var self = this,
				$ = self.$;

			self.state.on('change:text', function (e) {
				console.log('change:text');
			});
			self.state.on('change:icon', function (e) {
				console.log('change:icon');
			});
			return self._super();
		},
	});
	window.tinymce.ui.Factory.add(getCtrlTypeByPlugin(pluginCode), ctrl);
	console.log(
		'Registering popup picker control. pluginCode=' +
			pluginCode +
			'; ctrlCode=' +
			ctrlCode +
			'; ctrlType=' +
			getCtrlTypeByPlugin(pluginCode),
	);
}

// Соответствие плагина и контрола (например, в контроле Ссылка кнопка ВНЕЗАПНО вставляет ссылку НА КАРТИНКУ)
function getCtrlCodeByPlugin(pluginCode) {
	if (['image', 'link', 'media'].indexOf(pluginCode) === -1) {
		return 'c_' + pluginCode;
	} else {
		return 'c_dbmm';
	}
}

function getCtrlTypeByPlugin(pluginCode) {
	return 'inex_file_ctrl-' + pluginCode;
}

window.UARM_TMCE_UTIL.getCustomCtrl = function (pluginCode, options = {}) {
	console.log('UARM_TMCE_UTIL.getCustomCtrl ' + pluginCode, options);
	registerPopupPickerCtrl(pluginCode, options);
	return {
		name: 'TMCE_CUSTOM_CTRL-' + pluginCode,
		type: getCtrlTypeByPlugin(pluginCode),
		onclick: function (evt) {},
	};
};

export default function (props) {
	var pluginCode = props.name; // будет запрошен файл из папки с таким именем
	// registerPopupPickerCtrl(pluginCode);

	window.tinymce.PluginManager.add(pluginCode, function (editor) {
		var dataAttrName = 'data-' + pluginCode + '_id';
		var srcAttrName = 'src';
		var urlAttrName = 'data-url';
		var wAttrName = 'width';
		var hAttrName = 'height';
		var classNameForCurrentPlugin = pluginCode + classNameSuffix;

		var iconPath = '/uarm-fe/uarm-images/tinymce-' + pluginCode + '_icon.png';

		editor.addButton(pluginCode + '_btn', {
			// pluginName: pluginCode,
			classNameForCurrentPlugin: classNameForCurrentPlugin,
			title: 'Вставить/Редактировать ' + props.buttonTitleSuffix,
			image: iconPath, // icon теперь принимает не урл, а одно из предустановленных строковых значений
			onclick: dialog_open,
			onPostRender: function () {
				// stateselector почему-то не работает, поэтому так, см. http://www.tinymce.com/wiki.php/Tutorial:Migration_guide_from_3.x
				var ctrl = this;
				editor.on('NodeChange', function (evt) {
					var el = evt.element;

					// элемент сгенерирован одним из плагинов (PAE - Plugin for Async Element)
					var isPAE_any = el.className.indexOf(classNameSuffix) !== -1;

					// элемент сгенерирован конкретным плагином (к кот. относится кнопка)
					var isPAE_current = isPAE_any && el.className.indexOf(ctrl.settings.classNameForCurrentPlugin) !== -1;
					// двойное условие - микрооптимизация: если первая переменная false, вычисление условий дальше не идёт

					ctrl.active(isPAE_current);

					// далее - ручная обработка фокуса и удаления
					// (почему - см. дальше по слову window.UARM_TINYMCE_FOCUSED_EL)
					window.UARM_TINYMCE_FOCUSED_EL = isPAE_any ? el : null;

					// editor.fire('ObjectSelected', {target:el});
				});
			},
		});

		var isNew, node;
		var floatValues = [
			// УВАГА если будешь редактировать этот справочник - внимательно проверь все места где он используется, бо старые данные могут разломаться
			{
				text: 'Нет',
				value: '',
			},
			{
				text: 'По левому краю',
				value: 'fle',
			},
			{
				text: 'По правому краю',
				value: 'fri',
			},
		];

		function dialog_open() {
			node = editor.selection.getNode();
			var attrVal = node.getAttribute(dataAttrName);
			var attrUrl = node.getAttribute(urlAttrName);
			var attrW = node.getAttribute(wAttrName);
			var attrH = node.getAttribute(hAttrName);

			isNew = !attrVal; // если у выбранного элемента нет соотв. атрибута или он не заполнен - считаем что идёт операция создания нового элемента

			var windowTitlePrefix = isNew === true ? 'Вставка' : 'Редактирование';

			var body = [];

			if (pluginCode === 'icons') {
				body.push(
					{
						type: 'textbox',
						name: idCtrlName,
						label: 'ID',
						autofocus: true,
						disabled: true,
					},
					window.UARM_TMCE_UTIL.getCustomCtrl(pluginCode),
				);
				body.push({
					type: 'textbox', // какие ещё бывают: https://web.archive.org/web/20130712000558/http://www.tinymce.com/wiki.php/api4:namespace.tinymce.ui
					name: urlCtrlName,
					label: '',
					hidden: true,
				});
				body.push({
					type: 'textbox', // какие ещё бывают: https://web.archive.org/web/20130712000558/http://www.tinymce.com/wiki.php/api4:namespace.tinymce.ui
					name: wCtrlName,
					label: '',
					hidden: true,
				});
				body.push({
					type: 'textbox', // какие ещё бывают: https://web.archive.org/web/20130712000558/http://www.tinymce.com/wiki.php/api4:namespace.tinymce.ui
					name: hCtrlName,
					label: '',
					hidden: true,
				});
			} else {
				body.push(
					{
						type: 'textbox',
						name: idCtrlName,
						label: 'ID',
						autofocus: true,
					},
					window.UARM_TMCE_UTIL.getCustomCtrl(pluginCode),
				);
			}

			if (pluginCode !== 'photoreports' && pluginCode !== 'pion' && pluginCode !== 'icons') {
				body.push({
					type: 'listbox', // какие ещё бывают: https://web.archive.org/web/20130712000558/http://www.tinymce.com/wiki.php/api4:namespace.tinymce.ui
					name: floatCtrlName,
					label: 'Обтекание',
					values: floatValues,
				});
			}

			var wi = editor.windowManager.open(
				{
					title: windowTitlePrefix + ' ' + props.windowTitleSuffix + '\xA0\xA0\xA0', // \xA0 - это неразрывный пробел, иначе крестик закрытия окна налезает на заголовок
					body: body,
					onsubmit: dialog_submit,
				},
				{
					plugin_name: pluginCode,
				},
			);

			/* === Вводим значения, если элемент существует === */
			if (isNew === false) {
				// Айди
				wi.find('#' + idCtrlName).value(attrVal);

				// Float
				var $node = window.$(node);
				for (var i = 0, len = floatValues.length; i < len; i++) {
					var floatClass = floatValues[i].value;
					if (floatClass !== '' && $node.hasClass(floatClass) === true) {
						// пустое значение класса не обрабатываем, потому что $('<div class="aa  bb"></div>').hasClass('')===true (двойной пробел)
						wi.find('#' + floatCtrlName).value(floatClass);
						break;
					}
				}

				// Url
				wi.find('#' + urlCtrlName).value(attrUrl);

				// Width
				wi.find('#' + wCtrlName).value(attrW);

				// Height
				wi.find('#' + hCtrlName).value(attrH);
			}
		}

		function dialog_submit(evt) {
			// данные засабмиченной формы хранятся в evt.data

			var val_id = evt.data[idCtrlName];
			var val_float = evt.data[floatCtrlName];
			var val_url = evt.data[urlCtrlName];
			var val_w = evt.data[wCtrlName];
			var val_h = evt.data[hCtrlName];

			if (pluginCode === 'icons') {
				var val_src = urlUtil.mediaContextApi + val_url;
			}

			if (!/^\d+$/.test(val_id)) {
				// Тупо проверка на целое число.
				alert('Введите целочисленное значение ID');

				return false;
			} else {
				if (isNew) {
					editor.focus();
					var elAttrs = {
						contenteditable: false, // иначе если поместить курсор перед элементом и жать энтер, элемент будет клонироваться
						/*draggable: false, */
						class: classNameForCurrentPlugin + ' _PAE_holder ' + val_float,

						// это - для того чтобы можно было отловить событие nodechange (т.е. поймать фокус в смысле tinymce). Простой табиндекс не помогает, а наоборот всё портит.
						// ловить событие нужно для того чтобы по клику на элемент активизировать соответствующую кнопку плагина и затем по клику по ней мочь получить активный элемент (точнее его дата-айди)
						'data-mce-tabindex': '333',
						// обычный фокус в смысле CSS|JS научиться получать НЕ удалось (я старался по-всякому), ну и фиг с ним, обойдёмся без красоты (аутлайна)
						// если нужно будет - придётся ставить по клику и снимать по NodeChange класс
					};
					// Если нету контента в теге, то editor его удаляет.
					if (pluginCode !== 'icons') {
						elAttrs[dataAttrName] = val_id;
						editor.selection.setContent(editor.dom.createHTML('span', elAttrs, '\u00a0') + '<br/>');
					} else {
						editor.selection.setContent(
							editor.dom.createHTML('img', { class: classNameForCurrentPlugin, src: val_src, 'data-icons_id': val_id }),
						);
					}
					editor.undoManager.add();
				} else {
					// Элемент уже существует.
					node.setAttribute(dataAttrName, val_id);

					node.setAttribute(srcAttrName, val_src);

					node.setAttribute(urlAttrName, val_url);

					node.setAttribute(wAttrName, val_w);

					node.setAttribute(hAttrName, val_h);

					// Устанавливаем обтекание (сначала удаляем все возможные варианты, затем выставляем выбранный)
					var $node = window.$(node);
					for (var i = 0, len = floatValues.length; i < len; i++) {
						var floatClass = floatValues[i].value;
						if ($node.hasClass(floatClass) === true) {
							$node.removeClass(floatClass);
						}
					}
					$node.addClass(val_float);
				}
			}
		}
	});
}

function getPopContol(name) {
	// поиск контрола по имени в попап-окне
	return window.tinymce.activeEditor.windowManager.windows[0].find('#' + name)[0];
}

function getCurrentInput(nameDstCtrl = null) {
	var inpControl, inpType;
	/**
		Массив имён контролов, в которые может быть вписано значение.
		Ахтунг! По имени контрола в setVal определяется, что именно вставлять.
	*/

	if (nameDstCtrl) {
		var ctrl = getPopContol(nameDstCtrl);

		if (ctrl) {
			inpControl = ctrl;
			inpType = 1;
		}
	} else {
		var ctrlNamez = [
			idCtrlName, // презентации или фоторепортажи
			'source1', // media
			'src', // image
			'href', // link
		];

		// попытка найти в активном попап окне контрол с таким именем
		for (var i = 0; i < ctrlNamez.length; i++) {
			ctrl = getPopContol(ctrlNamez[i]);
			if (ctrl) {
				inpControl = ctrl;
				inpType = i;
				break;
			}
		}
	}

	// возвращаем найденный контрол и его тип
	return {
		type: inpType,
		control: inpControl,
	};
}

function setVal(arg1, arg2, arg3, arg4, arg5, nameDstCtrl = null) {
	var value = arg1;

	var toSetz = []; // массив "имя_контрола-значение" для установки новых, кхм, значений в форму.

	var mainInp = getCurrentInput(nameDstCtrl); // "главный" контрол ввода (ссылки или айди, в отличие от факультативных типа описания)

	var mainCtrlName = mainInp.control._name;

	switch (
		mainInp.type // в зависимости от того какой плагин нарисовал текущее окно, формируем данные для вставки в форму. Значение mainInp.type соответствует одному или нескольким плагинам (см. комментарии у case)
	) {
		case 0: // это презентации или фоторепортажи. Вставляем тупо ID.
			toSetz.push({
				name: mainCtrlName,
				value: value, // arg_id
			});
			toSetz.push({
				name: 'url_inp',
				value: arg2, // arg_name
			});
			toSetz.push({
				name: 'w_inp',
				value: arg3, // arg_name
			});
			toSetz.push({
				name: 'h_inp',
				value: arg4, // arg_name
			});

			break;

		case 1: // media. Вставляем сгенерённую ссылку (генерация см. ниже).
			toSetz.push({
				name: 'filename',
				value: arg2, // arg_name
			});

			// сделано дублировние для того чтобы исбежать "проваливания" из-за отсутсвия brake
			toSetz.push({
				name: mainCtrlName,
				value: value, // mediaLink + '?filename=' + arg_filename // filename в ссылке нужно плагину чтобы понять, как вставлять контент, см. guessMime в plugins\media\plugin.min.js. возможно filename стоит прогнать через encodeURIComponent
			});
			if (mainInp.type === 2) {
				// заполняем поле "Описание изображения" оно же alt картинки
				toSetz.push({
					name: 'alt',
					value: arg2, // arg_name
				});
			}
			break;
		case 2: // image. Вставляем сгенерённую ссылку (генерация см. ниже).
			toSetz.push({
				name: mainCtrlName,
				value: value, // mediaLink + '?filename=' + arg_filename // filename в ссылке нужно плагину чтобы понять, как вставлять контент, см. guessMime в plugins\media\plugin.min.js. возможно filename стоит прогнать через encodeURIComponent
			});
			if (mainInp.type === 2) {
				// заполняем поле "Описание изображения" оно же alt картинки
				toSetz.push({
					name: 'alt',
					value: arg2, // arg_name
				});
			}
			break;

		case 3: // link. Вставляем сгенерённую ссылку (генерация см. ниже).
			toSetz.push({
				name: mainCtrlName,
				value: value, // arg_id
			});

			// Если нет выделенного текста
			// возможно, это мертвая ветка кода, тк getPopContol('text') ничего не возвращает
			var popControl = getPopContol('text');
			if (popControl && popControl.value().length === 0) {
				toSetz.push({
					name: 'text',
					value: arg2, // arg_name
				}); // заполняем поле "Отображаемый текст
			}

			if (typeof arg3 !== 'undefined') {
				toSetz.push({
					name: 'ext',
					value: arg3,
				});
			}

			if (typeof arg4 !== 'undefined') {
				toSetz.push({
					name: 'size',
					value: arg4,
				});
			}

			if (typeof arg5 !== 'undefined') {
				toSetz.push({
					name: 'group',
					value: arg5,
				});
			}

			break;

		default:
			alert('Ошибка: не найден контрол для вставки значения');

			return;
	}

	for (var i = 0, len = toSetz.length; i < len; i++) {
		safeSetControlValueByName(toSetz[i].name, toSetz[i].value);
	}
}

function safeSetControlValueByName(controlName, valueToSet) {
	var ctrl = getPopContol(controlName);
	if (typeof ctrl === 'undefined') {
		console.error('Ошибка: контрол с именем «' + controlName + '» не найден в текущем окне плагина');
	} else {
		ctrl.value(valueToSet); // вообще под это дело (установку значение) есть геттер/сеттер: top.tinymce.activeEditor.windowManager.windows[0].value(cntrlName [,value])
		ctrl.fire('change'); // потому что просто установка значения не делает change (см. PIRS-6923 пункт 1)
	}
}
